import get from "lodash/get";
import isEmpty from "lodash/isEmpty";

export const isLoggedIn = state => !isEmpty(get(state, ["user", "userId"], ""));

